export default __webpack_public_path__ + "static/main_nav_illustration-8fa3b45ed403c7ee74d95175fb8fe910.svg";